import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Button.scss';

var Button = function Button(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onClick = _ref.onClick,
      type = _ref.type,
      disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement("button", {
    className: classNames('Button', className),
    disabled: disabled,
    onClick: onClick,
    type: type || 'button'
  }, children);
};

Button.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string]).isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool
};
export default Button;